module.exports = __webpack_public_path__ + "img/TaskIcon.1fdc2068.png";